<template>
	<div class="wishlist-ld">
		<div class="wishlist-ld__body">
			<h2 class="text-center h1">Lock Designer Wishlist</h2>
			<template v-if="!isLoggedIn">
				<div class="text-center">
					<Cta type="primary" size="lg" label="Log In / Create Account" @onClick="login()" :icon="[]" iconAlignment="left"> </Cta>
				</div>
			</template>
			<template v-if="isLoggedIn">
				<div class="wishlist-ld__top-bar">
					<template v-if="wishlists.length">
						<select name="wishlistSelection" id="wishlistSelection" :class="[`custom-select wishlist-ld__select`]" v-model="selectedWishlist" @change="updateWishlist()">
							<option v-for="wishlist in wishlists" :value="wishlist">{{ wishlist }}</option>
						</select>
					</template>
					<template v-else>
						<div class="mb-5 text-center p-3 bg-gray-light">You dont currently have any lock designer wishlists. These can be be added by going to <a href="/lock-designer">Lock Designer</a> and clicking the "Add to Wishlist" button</div>
					</template>
				</div>

				<ul v-if="wishlistItems.length" class="product-grid mb-5 product-grid--4-col">
					<li v-for="(wishlistItem, index) in wishlistItems" :key="wishlistItem.id" class="product-grid__item">
						<WishlistCard
							:displayName="wishlistItem.displayName"
							:finishDisplayName="wishlistItem.finishDisplayName"
							:id="wishlistItem.id"
							:imageUrl="wishlistItem.imageUrl+`?wid=400`"
							:url="wishlistItem.url"
							:itemsLength="wishlistItems.length"
							@itemDeleted="itemDeleted"
						></WishlistCard>
					</li>
				</ul>
			</template>
		</div>
	</div>
</template>




<script setup lang="ts">
interface Window {
	dataLayer: any[];
}
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from "vue-router";
import Cta from "Vue/components/lockDesigner/components/shared/Cta.vue";
import {WishlistItems, WishlistItemsToAdd} from "Api/apis";
import WishlistCard from "Vue/components/shared/WishlistCard.vue";
const router = useRouter();
const store = useStore();
const wishlistItems = ref([]);
const wishlists = ref([]);
const selectedWishlist = ref('');
const componentName = 'WishlistLockDesigner';

const isLoggedIn = computed(() => {
	return !!store?.state?.authToken;
});

const setFirstWishlistItem = () => {
	if (wishlists.value.length > 0) {
		selectedWishlist.value = wishlists.value[0] || '';
	}
};

const itemDeleted = async(isLastItem) => {
	//get the list of wishlists again and set it to the first item if the wishlist was entirely deleted
	if(isLastItem) {
		await getWishlistList();
	}

	await updateWishlist();
}

const updateWishlist = async() => {
	if(isLoggedIn.value) {
		const itemRequest = {
			wishlistName: selectedWishlist.value
		}
		let response = await WishlistItems(itemRequest, store?.state?.authToken);

		if(!response.isErrors) {
			wishlistItems.value = response.data?.items;
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'wishlistUser',
				data: response.data?.username
			});
		} else {
			//has errors
			console.log('no wishlist items data')
		}
	}
}

const getWishlistList = async() => {
	const lockDesignerWishlistItemsToAddRequest = {
		selections: store?.state?.selections,
		wishlistName: ''
	};
	const authToken = store?.state?.authToken;
	let items = await WishlistItemsToAdd(lockDesignerWishlistItemsToAddRequest, authToken);

	if(!items.isErrors) {
		wishlists.value = items.data?.wishlists;
	}

	setFirstWishlistItem();
	await updateWishlist();
};


watch(isLoggedIn, async(newValue, oldValue) => {
	if(newValue === true) {
		await getWishlistList();
	}
});

const login = async() => {
	await router.push('/wishlist/login');
}
</script>
